// extracted by mini-css-extract-plugin
export default {"logo":"LoadingComp_logo__MuFkj","fullLoader":"LoadingComp_fullLoader__FlXo7","smallLogo":"LoadingComp_smallLogo__T8Jm8"};